import { render, staticRenderFns } from "./NoticeContents.vue?vue&type=template&id=35e070ec&"
import script from "./NoticeContents.vue?vue&type=script&lang=ts&"
export * from "./NoticeContents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports